// eslint-disable-next-line
import { BasicLayout, RouterView } from '@/layouts'
// permissionMenuRoutes为用户权限菜单，用户有权限，才会展示其中的某些菜单
// 路由path是唯一值，不能重复，menu视图建议/m开头
// NOTE 目录只有本身路由，可简写（不用写RouterView重定向到下级）
export const permissionMenuRoutes = [
  {
    path: '/m/index',
    meta: {
      title: '首页',
    },
    component: () => import('@/pages/home/index'),
  },
  {
    path: '/m/scopeMain/guideManage',
    meta: {
      title: '导游管理',
    },
    component: RouterView,
    redirect: '/m/scopeMain/guideManage/guideManage',
    children: [
      {
        path: '/m/scopeMain/guideManage/guideManage',
        meta: {
          title: '悦游导游',
        },
        component: () => import('@/pages/scopes/main/guideManage/guide.vue'),
      },
      {
        path: '/m/scopeMain/guideManage/scenic/scenic',
        meta: {
          title: '悦游景点',
        },
        component: () => import('@/pages/scopes/main/guideManage/scenic.vue'),
      },
      {
        path: '/m/scopeMain/guideManage/guideProduct/guideProduct',
        meta: {
          title: '悦游项目',
        },
        component: () => import('@/pages/scopes/main/guideManage/guideProduct.vue'),
      },
      {
        path: '/m/scopeMain/guideManage/exchangeRate/exchangeRate',
        meta: {
          title: '每周汇率',
        },
        component: () => import('@/pages/scopes/main/guideManage/exchangeRate.vue'),
      },
      {
        path: '/m/scopeMain/guideManage/statement/statement',
        meta: {
          title: '团队结账单',
        },
        component: () => import('@/pages/scopes/main/guideManage/statement.vue'),
        children: [
          {
            path: '/m/scopeMain/guideManage/detail',
            meta: {
              title: '结账详情',
            },
            component: () => import('@/pages/scopes/main/guideManage/guideDetail.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/m/scopeMain/empAccountManage',
    meta: {
      title: '员工账号管理',
    },
    component: RouterView,
    redirect: '/m/scopeMain/empAccountManage/empAccountManage',
    children: [
      {
        path: '/m/scopeMain/empAccountManage/empAccountManage',
        meta: {
          title: '员工账号管理',
        },
        component: () => import('@/pages/scopes/main/systemSetting/empAccountManage/EmpAccountManage.vue'),
      },
      {
        path: '/m/scopeMain/empAccountManage/addEmployee',
        meta: {
          title: '新建员工',
        },
        component: () => import('@/pages/scopes/main/systemSetting/empAccountManage/AddEmployee.vue'),
      },
    ],
  }
]
export const asyncRouterMap = [
  {
    path: '/m',
    component: BasicLayout,
    // 动态添加
    children: [],
  },
  {
    path: '/b',
    component: RouterView,
    // 动态添加
    children: [],
  },
]

export const processedDefaultMenus = []
export const constantRouterMap = [
  {
    path: '/user',
    component: RouterView,
    redirect: '/user/login',
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/pages/user/Login'),
      },
    ],
  },
  {
    meta: {
      title: '404',
    },
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/pages/exception/404'),
  },
  {
    meta: {
      title: '403',
    },
    path: '/403',
    component: () => import(/* webpackChunkName: "fail" */ '@/pages/exception/403'),
  },
]
